import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { List } from 'immutable';

import { Spinner } from '../../helpers/Spinner';
import { UserCheckBox } from '../UserCheckBox';

import style from './style.module.css';

const UserListComponent = ({ users, loading = false, onChange }) => {
  if (loading) {
    return (
      <div className={style.loading}>
        <Spinner />
      </div>
    );
  }

  return (
    <div className={style.host}>
      {users.map(user => (
        <UserCheckBox
          key={user.get('id')}
          checked={user.get('selected', false)}
          onChange={onChange}
          userId={user.get('id')}
          userName={user.get('name')}
        />
      ))}
    </div>
  );
};

UserListComponent.propTypes = {
  loading: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  users: PropTypes.instanceOf(List).isRequired,
};

/** Grid of user checkboxes that filters the backlog. */
export const UserList = memo(UserListComponent);
